import React from "react";
import useLegalInfo from "@/hooks/useLegalInfo";
import { LegalLayout, Section, KV } from "@/components/LegalLayout";

export default function LegalNotice() {
  const { L, info } = useLegalInfo();
  return (
    <LegalLayout kicker="LSSI-CE" title="Aviso Legal" updated="junio 2026" testid="legal-notice-page">
      <Section title="1. Datos identificativos">
        <p>En cumplimiento del art. 10 de la Ley 34/2002 de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE):</p>
        <KV rows={[
          ["Titular", L("company_name")],
          ["NIF/CIF", L("tax_id")],
          ["Domicilio", L("address")],
          ["Email", L("email")],
          ["Datos registrales", info.registry || "No aplica"], ...(info.website ? [["Web", info.website]] : []),
        ]} />
      </Section>
      <Section title="2. Objeto">
        <p>AutoPresupuestos Pro es un servicio SaaS para que autónomos y pymes generen presupuestos, facturas y gestionen su contabilidad. El acceso implica la aceptación de este aviso legal.</p>
      </Section>
      <Section title="3. Propiedad intelectual">
        <p>Los contenidos, marca, diseño y código fuente son titularidad de {L("company_name")} o de sus licenciantes. Queda prohibida su reproducción sin autorización. Los datos y documentos que crees son tuyos.</p>
      </Section>
      <Section title="4. Responsabilidad">
        <p>Los presupuestos generados con IA son orientativos: el usuario debe revisar precios, cantidades e impuestos antes de enviarlos. {L("company_name")} no se responsabiliza del uso que se haga de ellos.</p>
      </Section>
      <Section title="5. Legislación aplicable">
        <p>Se rige por la legislación española. Para cualquier controversia, las partes se someten a los juzgados y tribunales del domicilio del consumidor o, si no lo es, de {L("jurisdiction_city")}.</p>
      </Section>
    </LegalLayout>
  );
}
